<form name='' class="filter-list-form" *ngIf="aggregation.Items.length > 0">
  <fieldset class="filter-group toggle-group type-compact">
    <div class="toggle-group__bar" (click)="expanded = !expanded" [ngClass]="{'is--active': expanded}">
      <legend class="toggle-group__bar__title">{{aggregation.Meta.alias || aggregation.Meta.title}}:</legend>

      <button type="button" class="block-group-toggle-button type-small" [ngClass]="{'is--active': expanded}">
        <span class="icon is--icon-plus">
          <svg class="icon-svg">
            <use xlink:href="/assets/gfx/svg-sprite.svg#icon-plus"></use>
          </svg>
        </span>

        <span class="icon is--icon-min">
          <svg class="icon-svg">
            <use xlink:href="/assets/gfx/svg-sprite.svg#icon-min"></use>
          </svg>
        </span>
      </button>
    </div>
    <ul class="filter-list filter-toggle-wrapper">
      <app-aggregation-item *ngFor="let val of aggregation.Items | sort" [labels]="labels"
        [type]="aggregation.Meta.title" [item]="val" (onSelect)="toggleKey($event, val)"></app-aggregation-item>
    </ul>
  </fieldset>
</form>